import { useEffect, useState, useCallback } from 'react';
import GeckoRequest from 'services/gecko-request';
import GeckoSocket from 'services/gecko-socket';

const loadingRing = `${process.env.PUBLIC_URL}/img/loading_ring.svg`;

const DEFAULT_USER = {
  first_name: '',
  last_name: '',
  additional: {
    profile_picture_url: loadingRing,
  },
  placeholder: true,
};

const useUser = (userId) => {
  const [user, setUser] = useState(DEFAULT_USER);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const reload = useCallback(() => {
    if (!userId) {
      return;
    }
    setIsLoading(true);
    return GeckoRequest.get(`/user/${userId}`)
      .then((user) => {
        setUser(user);
        setError(null);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [userId, setUser, setIsLoading]);

  useEffect(() => {
    reload();
  }, [reload]);

  const removeUser = useCallback(
    (deletedUser) => {
      if (deletedUser.id === user.id) {
        setUser(DEFAULT_USER);
      }
    },
    [user.id, setUser]
  );

  const updateUser = useCallback(
    (updatedUser) => {
      if (updatedUser.id === user.id) {
        setUser(updatedUser);
      }
    },
    [user.id, setUser]
  );

  useEffect(() => {
    if (user.id) {
      const typeKey = user.type === 'user' ? 'contact' : 'agent';
      GeckoSocket.on(`${typeKey}:updated`, updateUser);
      GeckoSocket.on(`${typeKey}:deleted`, removeUser);
      return () => {
        GeckoSocket.removeListener(`${typeKey}:updated`, updateUser);
        GeckoSocket.removeListener(`${typeKey}:deleted`, removeUser);
      };
    }
  }, [user.type, updateUser, removeUser]);

  return {
    user,
    error,
    reload,
    isLoading,
  };
};

export default useUser;
